function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMidnightFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27 15l-1.053-2.947L23 11l2.947-1.053L27 7l1.053 2.947L31 11l-2.947 1.053L27 15zM20.5 6l-.658-1.842L18 3.5l1.842-.658L20.5 1l.658 1.842L23 3.5l-1.842.658L20.5 6zM15.057 31C7.305 31 1 24.694 1 16.944 1 9.898 6.264 3.907 13.244 3.007a.908.908 0 01.705 1.593 9.534 9.534 0 00-3.36 7.268c0 5.262 4.282 9.543 9.545 9.543A9.53 9.53 0 0027.4 18.05a.917.917 0 011.062-.242.91.91 0 01.53.947C28.093 25.735 22.102 31 15.057 31zM10.728 5.496c-4.66 1.763-7.913 6.279-7.913 11.448 0 6.75 5.492 12.24 12.241 12.24 5.168 0 9.685-3.254 11.449-7.913a11.339 11.339 0 01-6.372 1.957c-6.266 0-11.363-5.098-11.363-11.36 0-2.298.694-4.51 1.958-6.372z",
    fill: props.color
  }));
}

export default SvgIconMidnightFilled;